export default class LinkButton {
  static get toolbox() {
    return {
      title: 'リンクボタン',
      icon:
        '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="ce-popover-item__custom-icon-image"><path stroke-linecap="round" stroke-linejoin="round" d="M13.19 8.688a4.5 4.5 0 0 1 1.242 7.244l-4.5 4.5a4.5 4.5 0 0 1-6.364-6.364l1.757-1.757m13.35-.622 1.757-1.757a4.5 4.5 0 0 0-6.364-6.364l-4.5 4.5a4.5 4.5 0 0 0 1.242 7.244" /></svg>',
    }
  }

  static get sanitize() {
    return {
      text: false,
      url: false,
    }
  }

  constructor({ data }) {
    this.data = {
      text: data.text || '',
      url: data.url || '',
    }
  }

  render() {
    const wrapper = document.createElement('div')
    wrapper.classList.add('cdx-link-button')

    const button = document.createElement('div')
    button.classList.add('cdx-link-button__button')

    const textInput = document.createElement('input')
    textInput.name = 'link-buttun-text-input'
    textInput.value = this.data && this.data.text ? this.data.text : ''
    textInput.classList.add('cdx-link-button__text-input')
    textInput.placeholder = 'テキストを入力'

    button.appendChild(textInput)
    wrapper.appendChild(button)

    return wrapper
  }

  renderSettings() {
    const urlInput = document.createElement('input')
    urlInput.value = this.data.url
    urlInput.classList.add('ce-popover-item-html__custom-text-input')
    urlInput.placeholder = 'リンク先URL'
    urlInput.addEventListener('change', event => {
      this.data.url = event.currentTarget.value
    })

    return [{ type: 'separator' }, { type: 'html', element: urlInput }]
  }

  save(blockContent) {
    const textInput = blockContent.querySelector('.cdx-link-button__text-input')

    return Object.assign(this.data, {
      text: textInput.value,
    })
  }

  validate(savedData) {
    return !!savedData.text.trim()
  }
}
